// Chakra Imports
import { Avatar, Flex, Icon, IconButton, Tooltip } from "@chakra-ui/react";
// Custom Components
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import QuickUserSearch from "components/Search/QuickUserSearch";
import AppointmentsWidget from "components/Navbars/AppointmentsWidget";
import DraftsMenu from "components/Navbars/DraftsMenu";
import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import { FiCamera, FiHardDrive, FiSearch } from "react-icons/fi";
import { loadLastInputMode } from "views/Dashboard/Scanner/scannerStorage";
import { useCanOpenScanner, useUserAuth } from "utils/site";

// Abre el escáner en el último modo usado (cámara/USB/manual).
const SCANNER_NAV = {
  camera: { to: "/admin/scanner", icon: FiCamera },
  usb: { to: "/admin/scanner-usb", icon: FiHardDrive },
  manual: { to: "/admin/scanner-manual", icon: FiSearch },
};

export default function HeaderLinks(props) {
  const { onOpen } = props;

  const { user: authUser } = useUserAuth();
  // Mismo gate que el botón "Abrir lector" de Accesos QR: administrador e
  // inspector. Profesor NO lo ve, aunque tenga el link "Escáner QR" del
  // sidebar habilitado por otro flag — ver useCanOpenScanner (utils/site.js).
  const hasScannerAccess = useCanOpenScanner();

  const scannerNav = SCANNER_NAV[loadLastInputMode()] || SCANNER_NAV.camera;

  return (
    <Flex align="center" gap={{ base: "8px", md: "16px" }} w={{ base: "100%", md: "auto" }}>
      <QuickUserSearch />

      <AppointmentsWidget userId={authUser?.id} />

      <DraftsMenu />

      {hasScannerAccess && (
        <Tooltip label="Escáner QR" placement="bottom">
          <IconButton
            as={NavLink}
            to={scannerNav.to}
            icon={<Icon as={scannerNav.icon} w="17px" h="17px" />}
            variant="ghost"
            size="sm"
            aria-label="Abrir escáner QR"
            _hover={{ bg: "transparent" }}
            _active={{ bg: "transparent" }}
          />
        </Tooltip>
      )}

      <SidebarResponsive />

      {/* Único ícono de usuario — abre el panel lateral derecho */}
      <Avatar
        size="sm"
        name={authUser?.first_name ? `${authUser.first_name} ${authUser.last_name || ''}`.trim() : authUser?.username}
        bg="coral.500"
        color="white"
        cursor="pointer"
        onClick={onOpen}
        _hover={{ opacity: 0.85 }}
      />
    </Flex>
  );
}

HeaderLinks.propTypes = {
  onOpen: PropTypes.func,
};
